import { render, staticRenderFns } from "./UserAccountNotification.vue?vue&type=template&id=c59a0686&"
import script from "./UserAccountNotification.vue?vue&type=script&lang=js&"
export * from "./UserAccountNotification.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports